import { FunctionComponent, useCallback } from 'react'
import { useRootStore } from 'stores/RootStore'

export interface ConfirmDrawer {
  onCancel: () => void
  onConfirm: () => void
  onPressOutside: () => void
}

export interface ConfirmDrawerProps {
  msg: string
  confirmText?: string
}

export const useConfirmDrawer = (Modal: FunctionComponent<React.PropsWithChildren<ConfirmDrawer>>) => {
  const { drawersStore } = useRootStore()
  const { closeDrawer, openDrawer } = drawersStore
  return useCallback(
    (props?: ConfirmDrawerProps) =>
      new Promise<boolean>((resolve) => {
        const drawerProps = {
          onCancel: () => {
            resolve(false)
            closeDrawer()
          },
          onConfirm: () => {
            resolve(true)
            closeDrawer()
          },
          onPressOutside: () => {
            resolve(false)
            closeDrawer()
          },
          ...props,
        }
        openDrawer(Modal, drawerProps)
      }),
    [closeDrawer, openDrawer, Modal],
  )
}
